// extracted by mini-css-extract-plugin
module.exports = {"block":"loadBlock_block__362EM","fadeIn":"loadBlock_fadeIn__3TksR"};